module.exports = __webpack_public_path__ + "img/OVS-2.e0550ff8.png";